import { css } from 'styled-components';

export const requirementsList = css`
  margin: var(--theme-spacing-xs, 8px) 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const requirementsItem = css`
  margin: 0;
  color: var(--Neutrals-Black-base, #1e1e29);
  font-family: 'NOTHS Sans No3';
  font-size: var(--font-size-Body-SM, 12px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--line-height-Body-SM, 18px);
  letter-spacing: -0.12px;
`;

export const minRequiredHint = css`
  margin: 12px 0 0;
  color: var(--Text-base-text-secondary, #666463);
  font-family: Lato;
  font-size: var(--font-size-body-SM, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--line-height-body-SM, 18px);
  letter-spacing: 0.13px;
`;
